import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Loader2, ArrowLeft, Calendar } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="App"><Navbar /><div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#F0005A]" /></div></div>;
  if (notFound || !post) return (
    <div className="App"><Navbar />
      <div className="text-center py-32">
        <p className="text-slate-600 font-medium">Artikel tidak ditemukan.</p>
        <Link to="/blog" className="text-[#F0005A] text-sm mt-3 inline-block">← Kembali ke Blog</Link>
      </div>
      <Footer />
    </div>
  );

  return (
    <div className="App">
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center text-sm text-slate-500 hover:text-[#F0005A] mb-6">
          <ArrowLeft className="w-4 h-4 mr-1.5" /> Kembali ke Blog
        </Link>
        <div className="flex items-center gap-1.5 text-xs text-slate-400 mb-3">
          <Calendar className="w-3.5 h-3.5" />
          {new Date(post.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" })}
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#00133F] leading-tight" data-testid="blog-post-title">{post.title}</h1>
        {post.cover_image && (
          <div className="mt-8 rounded-2xl overflow-hidden border border-slate-200">
            <img src={post.cover_image} alt={post.title} className="w-full max-h-[420px] object-cover" />
          </div>
        )}
        <div className="mt-8 prose prose-slate max-w-none">
          {post.content.split("\n").filter((l) => l.trim()).map((para, i) => (
            <p key={i} className="text-slate-700 leading-relaxed mb-4 whitespace-pre-line">{para}</p>
          ))}
        </div>
      </article>
      <Footer />
    </div>
  );
}
